/* eslint-disable max-lines */
/* eslint-disable max-lines */
import { POST_FIELDS } from '@/services/charts-service';
import {
  DEFAULT_SIZES,
  DATA_TYPE,
  COMPONENT_TYPE,
  FILTER_NAMES,
  WIDTH,
  HEIGHT,
} from '@/store/modules/cards/constants';
import { Flags } from '@/plugins/rollout';
/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'PNP_1',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'OwnedEarnedPostReach',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev],
    props: {
      title: 'Alcance de publicações Owned e Earned',
      originalTitle: 'Alcance de publicações Owned e Earned',
      isExpandedCard: false,
      description: 'Somatória de publicações propietárias e não propietárias coletadas na pesquisa.',
    },
  },
  {
    id: 'PNP_2',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByTag',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev],
    props: {
      title: 'Alcance Sentimento por Tag Owned + Earned',
      originalTitle: 'Alcance Sentimento por Tag Owned + Earned',
      isExpandedCard: false,
      description: 'soma do alcance e distribuição de publicações proprietárias e não proprietárias pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'PNP_3',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByTerms',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev],
    props: {
      title: 'Sentimento por termo Owned + Earned',
      originalTitle: 'Sentimento por termo Owned + Earned',
      isExpandedCard: false,
      description: 'soma da distribuição de publicações proprietárias e não proprietárias  por termos mais mencionados e sua divisão de polaridade.',
      tags: 'Termos; Sentimento',
    },
  },
  {
    id: 'PNP_4',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SentimentByThemes',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev],
    props: {
      title: 'Sentimento por tema Owned + Earned',
      originalTitle: 'Sentimento por tema Owned + Earned',
      isExpandedCard: false,
      description: 'Soma da distribuição de publicações proprietárias e não proprietárias pelos Temas cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
      tags: 'Sentimento, Categorias e Anotações',
    },
  },
  {
    id: 'PNP_5',
    width: WIDTH.SMALL,
    height: HEIGHT.SMALL,
    component: 'BrandHealthOwnedEarned',
    componentType: COMPONENT_TYPE.GAUGE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_LISTENING,
    hideInLibrary: [Flags.showSacListeningComponents, Flags.showStudioDev],
    props: {
      title: 'Saúde da marca Owned + Earned',
      originalTitle: 'Saúde da marca Owned + Earned',
      isExpandedCard: false,
      description: 'Representa, em forma de gauge, o resultado da equação: (publicações proprietárias e não proprietárias positivas / publicações proprietárias e não proprietárias coletadas * 100) - (publicações proprietárias e não proprietárias negativas / publicações proprietárias e não proprietárias coletadas * 100).',
      tags: 'Sentimento',
    },
  },
];
